import _styled, { default as _styled2 } from "styled-components";
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useVirtual } from 'react-virtual';
const LIST_MAX_HEIGHT = 450;
const VirtualizedList = _ref => {
  let {
    renderItem,
    renderLoader,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    size
  } = _ref;
  const parentRef = useRef(null);
  const pageSizeWithLoader = hasNextPage || isFetchingNextPage ? size + 1 : size;
  const pageSize = hasNextPage || isFetchingNextPage ? size - 1 : size;
  const rowVirtualizer = useVirtual({
    size: pageSizeWithLoader,
    parentRef
  });
  useEffect(() => {
    const lastItem = rowVirtualizer.virtualItems[rowVirtualizer.virtualItems.length - 1];
    const isLastItemVisible = (lastItem === null || lastItem === void 0 ? void 0 : lastItem.index) > pageSize;
    if (!lastItem) {
      return;
    }
    if (isLastItemVisible && hasNextPage && !isFetchingNextPage) {
      fetchNextPage === null || fetchNextPage === void 0 ? void 0 : fetchNextPage();
    }
  }, [hasNextPage, fetchNextPage, isFetchingNextPage, rowVirtualizer.virtualItems, pageSize]);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: parentRef,
    $_css: LIST_MAX_HEIGHT
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: rowVirtualizer.totalSize
  }, rowVirtualizer.virtualItems.map(virtualRow => /*#__PURE__*/React.createElement("div", {
    key: virtualRow.index,
    ref: virtualRow.measureRef,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      transform: "translateY(".concat(virtualRow.start, "px)")
    }
  }, /*#__PURE__*/React.createElement("div", null, virtualRow.index > pageSize ? isFetchingNextPage ? renderLoader === null || renderLoader === void 0 ? void 0 : renderLoader() : null // Nothing more to load
  : renderItem === null || renderItem === void 0 ? void 0 : renderItem(virtualRow.index))))));
};
VirtualizedList.displayName = 'VirtualizedList';
VirtualizedList.propTypes = {
  /** Function that renders the item */
  renderItem: PropTypes.func,
  /** Function that renders the item loader */
  renderLoader: PropTypes.func,
  /** List of items */
  size: PropTypes.number.isRequired
};
export default VirtualizedList;
var _StyledDiv = _styled("div")(p => ({
  minHeight: 120,
  maxHeight: p.$_css,
  overflow: 'auto'
}));
var _StyledDiv2 = _styled2("div").withConfig({
  displayName: "VirtualizedList___StyledDiv2",
  componentId: "sc-55wrij-0"
})(p => ({
  height: p.$_css2,
  width: '100%',
  position: 'relative'
}));
//# sourceMappingURL=VirtualizedList.js.map